export default function DeepSeekIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="6" fill="#1C4ED8"/>
      <text x="12" y="16.5" textAnchor="middle" fontSize="11" fontWeight="700" fill="white" fontFamily="sans-serif">DS</text>
    </svg>
  );
}
